import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import InfiniteScroll from 'components/shared/loaders/infinite-scroll';

import View from 'components/merchant/view';
import VenueTile from 'components/merchant/venues/tile';

import PlaceholderLoader from 'components/shared/loaders/placeholder-loader';

import userActions from 'actions/users/actions';

import * as userSelectors from 'sagas/selectors/user';

const messages = {
  title: 'Venues',
  description: 'Manage all of your Venue and Space details from this page. Add new locations, update contact details, and manage all your pictures and content',
}

const VenuesList = ({ list, fetchUserVenues, userVenuesInfo: { isFetching, page, lastPage }, setUserVenuesIsFetching }) => {
  const baseUrl = 'venues/venue/';

  useEffect(() => {
    fetchUserVenues();
  }, []);

  const scrollAction = () => fetchUserVenues({ page: page + 1 });
  const errorAction = () => setUserVenuesIsFetching(false);

  const renderHeader = () => <div className="pb-10">
    <h5 className="font-bold">{messages.title}</h5>
    <small className="text-gray-600">{messages.description}</small>
  </div>;

  const renderPlaceholder = () => {
    return (
      <PlaceholderLoader>
        <VenueTile isLoading={true}/>
        <VenueTile isLoading={true}/>
        <VenueTile isLoading={true}/>
      </PlaceholderLoader>
    );
  };

  return (
    <View theme="grey">
      <InfiniteScroll
        isFetching={isFetching}
        hasMore={page < lastPage}
        action={scrollAction}
        errorAction={errorAction}
        renderPlaceholderLoader={renderPlaceholder}
      >
        { renderHeader() }
        <div className="flex flex-wrap">
          <VenueTile url={`${baseUrl}add`} />
          { list && list.map((venue, idx) => venue && <VenueTile url={`${baseUrl}${venue.id}`} venue={venue || null} key={idx} />) }
        </div>
      </InfiniteScroll>
    </View>
  );
}

VenuesList.propTypes = {
  list: PropTypes.array,
  userVenuesInfo: PropTypes.shape({
    isFetching: PropTypes.bool,
    page: PropTypes.number,
    lastPage: PropTypes.number,
  }),
  fetchUserVenues: PropTypes.func.isRequired,
  setUserVenuesIsFetching: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  list: userSelectors.userVenuesListShow(state),
  userVenuesInfo: userSelectors.userVenuesInfo(state),
});

const mapDispatchToProps = {
  fetchUserVenues: userActions.fetchUserVenues,
  setUserVenuesIsFetching: userActions.setUserVenuesIsFetching,
};

export default connect(mapStateToProps, mapDispatchToProps)(VenuesList);
